import PropTypes from 'prop-types';
import Cookies from 'universal-cookie';
import { useRef, useState, createContext } from 'react';
import { authLog, authTrail, fingerprint } from 'src/sentry';

import { postToApp } from 'src/utils/post-to-app';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const cookies = new Cookies();
  const defaultAuth = cookies.get('megi-authorization');

  const [auth, setAuth] = useState(defaultAuth);
  // remembers the token we last revoked so a stale copy still held by the
  // native app isn't passively re-adopted on the login screen
  const clearedToken = useRef(null);

  const handleSetAuth = (token) => {
    if (!token) {
      authLog('auth:clear', {
        prevTokenFp: fingerprint(auth),
        route: window.location.pathname,
        nativeWebview: !!window.ReactNativeWebView,
      });
      clearedToken.current = auth;
      cookies.remove('megi-authorization', { path: '/' });
      postToApp('SET_AUTH_TOKEN', { token: null });
      setAuth(null);
      return;
    }
    authTrail('auth:set', { tokenFp: fingerprint(token), route: window.location.pathname });
    // set age to 1 year
    cookies.set('megi-authorization', token, { path: '/', maxAge: 31556952 });
    setAuth(token);
  };

  return (
    <AuthContext.Provider value={{ auth, setAuth: handleSetAuth, clearedToken }}>{children}</AuthContext.Provider>
  );
};

export default AuthContext;

AuthProvider.propTypes = {
  children: PropTypes.any,
};
